module.exports = {
  REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST: 'REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST',
  REPATRIATIONS_TRANSACTIONS_EXECUTE_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_EXECUTE_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_EXECUTE_FAILURE: 'REPATRIATIONS_TRANSACTIONS_EXECUTE_FAILURE',
};
